import React, { Component } from 'react';
import Container from "@/components/Container";
import Iframe from '@/components/Iframe';

export default class AddressBase extends Component {
  render () {
    const IframeDom = Iframe({
      src: 'https://t.xiaoyuanhao.com/v2-iframe/oa/coursePlaceSet',
    })

    return (<Container breStates defaultPadding>
      <div style={{padding: '9px 17px'}}>
        <IframeDom />
      </div>
    </Container>);
  }
}
